// Both endpoints must receive the same case sources and representation.
export function panaceiaCaseRequest(fields) {
  const input = { area: fields.area, tipoPeca: fields.acao, intencao: fields.publicacao.trim() }
  for (const key of ['orientacoes', 'parteRepresentada', 'poloProcessual', 'advogadoResponsavel',
    'oabResponsavel', 'tribunalOrigem', 'acordaoPrincipal']) {
    const value = (fields[key] || '').trim()
    if (value) input[key] = value
  }
  if (fields.naturezaDecisao) input.naturezaDecisao = fields.naturezaDecisao
  if (fields.consultaJuditId) {
    input.consultaJuditId = fields.consultaJuditId
    input.consultaJuditVersao = fields.consultaJuditVersao
    input.processReference = fields.processReference
    input.documentosJudit = (fields.documentosJudit || []).map((documento) => ({
      documentoId: documento.documentoId, documentoVersao: documento.documentoVersao,
      paginaInicial: documento.paginaInicial, paginaFinal: documento.paginaFinal,
      tipo: documento.tipo, posicaoAtualConfirmada: documento.posicaoAtualConfirmada === true,
    }))
  }
  return input
}

export function panaceiaGenerationRequest(fields) {
  const provider = fields.provedorGeracao || 'ollama'
  return { ...panaceiaCaseRequest(fields), provedorGeracao: provider,
    ...(fields.modeloGeracao ? { modeloGeracao: fields.modeloGeracao } : {}),
    ...(provider === 'claude' ? {} : { temperatura: Number(fields.temperatura ?? 0.2), topP: Number(fields.topP ?? 0.9) }),
    ...(!fields.consultaJuditId && fields.pesquisaJurisprudencialId ? { pesquisaJurisprudencialId: fields.pesquisaJurisprudencialId } : {}) }
}
